<template>
  <v-app>
    <!-- :style="'background-image: url('+ require('@/assets/img/bg_login.png') +')'" -->
    <div class="login h-100">
      <v-container class="h-100">
        <v-row class="h-100" align="center" justify="center">
          <v-col cols="12" sm="5" md="4" lg="3" xl="2" v-if="esqueceu == 0">
            <div class="text-center mb-5">
              <img alt="Logo" src="@assets/img/logo.png" />
            </div>
            <v-form ref="formLogin">
              <v-text-field
                aria-label="Login"
                class="mb-2"
                label="Login"
                outlined
                autofocus
                ref="inputLogin"
                :rules="[rules.required]"
                :disabled="loadingLogin"
                :loading="loadingLogin"
                required=""
                type="text"
                v-model="login.login"
              ></v-text-field>
              <v-text-field
                @click:append="show1 = !show1"
                aria-label="Senha"
                class="mb-2"
                label="Senha"
                hint="Mínimo 6 caracteres"
                counter
                outlined
                required=""
                :loading="loadingLogin"
                :disabled="loadingLogin"
                :type="show1 ? 'text' : 'password'"
                v-model="login.password"
                :append-icon="show1 ? 'remove_red_eye' : 'visibility_off'"
                :rules="[rules.required, rules.min]"
              ></v-text-field>
              <v-row no-gutters align="center" justify="space-between">
                <div class="text--thin text-right pt-1 text-lost" @click="goEsqueceu()">
                  <!-- Esqueci minha senha -->
                </div>
                <v-btn
                  color="primary"
                  type="submit"
                  depressed
                  :disabled="loadingLogin"
                  @click="submitLogin()"
                  :loading="loadingLogin"
                >
                  Entrar
                </v-btn>
              </v-row>
            </v-form>
          </v-col>
          <v-col cols="12" sm="5" md="4" lg="3" xl="2" v-if="esqueceu == 1">
            <h2 class="text-h2 text-center">Esqueceu a senha?</h2>
            <p class="text mt-3 mb-4">Preencha seu e-mail abaixo para receber os dados de redefinição da sua senha.</p>
            <v-form ref="formEsqueceu">
              <v-text-field
                v-model="esquecer.usu_email"
                label="E-mail"
                outlined
                autofocus
                :rules="[rules.required, rules.email]"
                :disabled="loadingLogin"
                :loading="loadingLogin"
              ></v-text-field>
              <v-row no-gutters align="center" justify="space-between">
                <v-btn
                  color="cancel"
                  :disabled="loadingLogin"
                  :loading="loadingLogin"
                  @click="voltarLogin()"
                  type="button"
                >
                  Voltar
                </v-btn>
                <v-btn
                  color="primary"
                  @click="sendRequestEmail()"
                  :disabled="loadingLogin"
                  :loading="loadingLogin"
                >
                  Enviar
                </v-btn>
              </v-row>
            </v-form>
          </v-col>
          <v-col cols="12" sm="5" md="4" lg="3" xl="2" v-if="esqueceu == 2">
            <h2 class="text-h2 text-white">Redefinir senha</h2>
            <p class="text text-white mt-3 mb-4">Por favor, preencha sua nova senha</p>
            <v-form ref="formPasswd">
              <v-text-field
                @click:append="showPassword = !showPassword"
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'remove_red_eye' : 'visibility_off'"
                v-model="novaSenha.password"
                @paste.prevent
                outlined
                required=""
                hint="Mínimo 6 caracteres"
                counter
                :rules="[rules.required, rules.min]"
                label="Senha"
                :loading="loadingLogin"
                :disabled="loadingLogin"
              ></v-text-field>
              <v-text-field
                @click:append="showRepeatPassword = !showRepeatPassword"
                :type="showRepeatPassword ? 'text' : 'password'"
                :append-icon="showRepeatPassword ? 'remove_red_eye' : 'visibility_off'"
                v-model="novaSenha.passwordRepeat"
                required=""
                outlined
                @paste.prevent
                hint="Mínimo 6 caracteres"
                counter
                :rules="confirmPasswordRules"
                label="Repita Senha"
                :loading="loadingLogin"
                :disabled="loadingLogin"
              ></v-text-field>
              <v-row no-gutters align="center" justify="space-between">
                <v-btn
                  color="cancel"
                  :disabled="loadingLogin"
                  :loading="loadingLogin"
                  @click="voltarLogin(1)"
                  type="button"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingLogin"
                  :disabled="loadingLogin"
                  @click="storeNewPassword()"
                >
                  Enviar
                </v-btn>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
        <v-dialog
          v-model="dialogConfirma"
          persistent
          max-width="400"
        >
          <v-card>
            <v-card-title class="text-h5">
              Tem certeza que quer cancelar?
            </v-card-title>
            <v-card-text>Cancelando a recuperação de senha, será necessário confirmar o e-mail novamente.</v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-row align="center" justify="space-between" no-gutters class="py-1">
                <v-btn
                  color="cancel"
                  @click="dialogConfirma = false"
                >
                  Voltar
                </v-btn>
                <v-btn
                  color="success"
                  @click="voltarLogin()"
                >
                  Cancelar
                </v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
  </v-app>
</template>
<script>
import Api from '@API'
export default {
  data () {
    return {
      loadingLogin: false,
      show1: false,
      esqueceu: 0,
      showPassword: false,
      showRepeatPassword: false,
      dialogConfirma: false,
      rules: {
        required: value => !!value || 'Obrigatório.',
        min: v => v.length >= 6 || 'Mínimo 6 caracteres',
        emailMatch: () => (`O usuário e a senha utlizados não conferem`),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'E-mail inválido.'
        }
      },
      confirmPasswordRules: [
        (value) => !!value || 'Confirme a senha',
        (value) =>
          value === this.novaSenha.password || 'A confirmação da senha não corresponde.'
      ],
      novaSenha: {
        password: '',
        passwordRepeat: ''
      },
      esquecer: {
        usu_email: ''
      },
      login: {
        login: '',
        password: ''
      }
    }
  },
  methods: {
    voltarLogin (cancelar = null) {
      if (cancelar) {
        this.dialogConfirma = true
      } else {
        this.dialogConfirma = false
        this.$router.push({ name: 'Login' }).catch(() => {})
        this.esqueceu = 0
        setTimeout(() => {
          if (this.$refs.formLogin) {
            this.$refs.formLogin.resetValidation()
          }
          this.$refs.inputLogin.focus()
        })
      }
    },
    goEsqueceu () {
      this.esqueceu = 1
      setTimeout(() => {
        if (this.$refs.formEsqueceu) {
          this.$refs.formEsqueceu.resetValidation()
        }
      })
    },
    async storeNewPassword () {
      if (!this.$refs.formPasswd.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.loadingLogin = true
      this.novaSenha.uuid = this.$route.query.v
      await Api.post('usuario/nova-senha', this.novaSenha)
        .then((response) => {
          this.loadingLogin = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.novaSenha = {
            password: '',
            passwordRepeat: ''
          }
          this.esqueceu = 0
          localStorage.setItem('userData', JSON.stringify(response.data))
          localStorage.setItem('user', JSON.stringify(response.data.usuario))
          localStorage.setItem('token', JSON.stringify(response.data.usuario.usu_token))
          this.$router.push({ name: 'Home' }).catch(() => {})
        })
        .catch((error) => {
          this.loadingLogin = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao criar a nova senha!',
            color: 'error'
          })
        })
    },
    async sendRequestEmail () {
      if (!this.$refs.formEsqueceu.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.loadingLogin = true
      await Api.post('usuario/esqueceu-senha', this.esquecer)
        .then((response) => {
          this.loadingLogin = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.esquecer = {
            usu_email: ''
          }
          this.esqueceu = 0
          this.$root.SnackControl.open(this, {
            text: 'Um e-mail foi enviado com instruções para a redefinição da sua senha :)',
            color: 'success'
          })
        })
        .catch((error) => {
          this.loadingLogin = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao criar a nova senha!',
            color: 'error'
          })
        })
    },
    async submitLogin () {
      if (!this.$refs.formLogin.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.loadingLogin = true
      let dados = {
        usu_apelido: this.login.login,
        password: this.login.password
      }
      Api.post('usuario/login', dados)
        .then((response) => {
          this.loadingLogin = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            this.disabled = false
            return false
          }
          localStorage.setItem('userData', JSON.stringify(response.data))
          localStorage.setItem('user', JSON.stringify(response.data.usuario))
          localStorage.setItem('token', JSON.stringify(response.data.usuario.usu_token))
          this.$router.push({ name: 'Home' }).catch(() => {})
        })
        .catch((error) => {
          this.loadingLogin = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao efetuar o login!',
            color: 'error'
          })
        })
    }
  },
  created () {
    console.log(this.$route.query.v)
    if (this.$route.query.v) {
      // esqueceu = 2: recuperação de senha
      this.esqueceu = 2
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/app.scss";
.login {
  background-position: center right;
  background-repeat: no-repeat;
  background-size: contain;
  @media (max-width: 595px){
    background: none;
    padding: 0 20px;
  }
}
.text-lost {
  cursor: pointer;
  font-size: 15px;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/TheLogin.vue